export default "<div class=\"auth-wrapper\">\n  <router-outlet></router-outlet>\n</div>\n"